// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AH6N","toggleWrap":"styles_toggleWrap__3ghCI","content":"styles_content__2tKzI","selectAreaCode":"styles_selectAreaCode__3ZrPJ"};